import {
  RepaymentInsert,
  GetRepaymentAmountMax,
  GetRepayment,
} from "./api";

import http from "config/http";

const repayApi = {
  getRepayment: async ({ basketOwnerId = 1, coinId = -1 }) => await http.get(GetRepayment({ basketOwnerId, coinId })),

  getRepaymentAmountMax: async ({ basketOwnerId, coinId }) => await http.get(GetRepaymentAmountMax({ basketOwnerId, coinId })),

  repaymentInsert: async (body) => await http.post(RepaymentInsert, body),
};

export default repayApi;
